import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { EventsService } from '../../services/events.service';
import { Event } from '../../interfaces/event';
import { ReservationsService } from '../../services/reservations.service';
import { AuthService } from '../../services/auth.service';
import { MapComponent } from "../map/map.component";
import { MatDialog } from '@angular/material/dialog';
import { ResponseModalComponent } from '../response-modal/response-modal.component';
import { Title } from '@angular/platform-browser';
import { faArrowLeft, faCalendarAlt, faChevronDown, faChevronUp, faExclamationCircle, faImage, faInfoCircle, faMapMarkerAlt, faQrcode, faWineGlass, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonComponent } from '../button/button.component';
import { BreweryLogoComponent } from '../brewery-logo/brewery-logo.component';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { Reservation } from '../../interfaces/reservation';
import { Branch, BranchCategory } from '../../interfaces/branch';
import { ProductCategory } from '../../interfaces/product-category';
import { QrmodalComponent } from '../qrmodal/qrmodal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BranchScheduleComponent } from '../branch-schedule/branch-schedule.component';

@Component({
  selector: 'app-reservation',
  standalone: true,
  imports: [CommonModule, MapComponent, FontAwesomeModule, BreweryLogoComponent, SkeletonComponent, RouterModule, ButtonComponent, TranslateModule, BranchScheduleComponent],
  templateUrl: './reservation.component.html',
  styleUrl: './reservation.component.scss'
})
export class ReservationComponent {
  reservation: Reservation | null = null;
  branches: Branch[] = []
  categories: ProductCategory[] = []
  isAuthenticated = false;
  loading: boolean = false;
  isLoadingReservation: boolean = true;
  hasPassed: boolean = true;
  faCalendarAlt = faCalendarAlt;
  faImage = faImage
  faArrowLeft = faArrowLeft
  faWineGlass = faWineGlass
  faMapMarkerAlt = faMapMarkerAlt
  faExclamationCircle = faExclamationCircle
  faInfoCircle = faInfoCircle
  faQrcode = faQrcode
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faClock = faClock;

  expandedItemIndex: number | null = null;
  expandedScheduleBranchId: number | null = null;
  
  constructor(
    private route: ActivatedRoute,
    private eventsService: EventsService,
    private reservationService: ReservationsService,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog,
    private title: Title,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const locator = params['locator'];
      this.loadReservation(locator);
    });
    this.authService.getTokenChanges().subscribe(token => {
      this.isAuthenticated = !!token;
    });
  }

    openQRModal(item: any) {
      this.dialog.open(QrmodalComponent, {
        data: {
          title: item.typeId == 1
            ? this.translate.instant('reservation.eventPrefix') + item.event.title
            : this.translate.instant('reservation.customRoute'),
          qrCode: item.qr.qrCode,
          eventDate: item.typeId == 1 ? item.event.date : item.endDate,
          visitorName: item.visitorName,
          qrId: item.qr.id,
        }
      });
    }

  loadReservation(locator: string): void {
    this.isLoadingReservation = true;
    this.reservationService.getReservationDetails(locator).subscribe(
      data => {
        if(data.items) {
          data.items.forEach((item: any) => {
             if(item.typeId === 2 && item.selections) {
                item.branches = item.selections.map((s: any) => s.branch);
             }
          });
        }
        this.reservation = data

        this.isLoadingReservation = false;
      },
      error => {
        console.error('Error loading reservation:', error);
        this.isLoadingReservation = false;
        this.router.navigate([''])
      }
    );
  }

  goToLogin(){
    this.router.navigate(['login'])
  }

  goToBrewery(slug: string): void {
    this.router.navigate(['/brewery', slug]);
  }

  // reserveEvent(): void {
  //   if(this.loading){
  //     return
  //   }

  //   if(!this.isAuthenticated){
  //     this.openErrorModal('Debes estar logueado para reservar este evento', 'error','Un ultimo paso')
  //     return
  //   }

  //   if(this.hasPassed){
  //     const response = {error:{message:'El evento es pasado, no puedes reservar'}}
  //     this.openErrorModal('No puedes reservas un evento pasado. ¡Te invitamos a que veas el resto de opciones que brinda DrinkHopping!', 'error', 'Evento finalizado')
  //     return
  //   }

  //   this.loading = true;
  //   if (this.event) {
  //     this.reservationService.reserveEvent(this.event.id).subscribe(
  //       (res) => {
  //         this.loading = false
  //         this.router.navigate(['payment', res.locator])
  //       },
  //       error => {
  //         console.error('Error reserving event:', error)
  //         this.openErrorModal(error.error.message, 'error', 'Algo ha salido mal...')
  //         this.loading = false
  //       },
  //     );
  //   }
  // }

  // openErrorModal(message: string, type:string, title:string) {   
  //   this.dialog.open(ResponseModalComponent, {
  //     data: {
  //       title: title,
  //       type: type,
  //       message: message ?? 'Intentalo mas tarde',
  //     }
  //   });
  // }
  toggleItem(index: number): void {
    if (this.expandedItemIndex === index) {
      this.expandedItemIndex = null;
    } else {
      this.expandedItemIndex = index;
    }
  }

  isBranchVisited(item: any, branchId: number): boolean {
    if (!item.visits || item.visits.length === 0) return false;

    if (item.typeId === 1) {
      // Para eventos, verificar si existe una visita con ese branchId
      return item.visits.some((visit: any) => visit.branchId === branchId);
    } else if (item.typeId === 2) {
      // Para custom hopping, verificar si existe una visita con ese branchId
      // (la categoría se verifica en isSelectionVisited)
      return item.visits.some((visit: any) => visit.branchId === branchId);
    }

    return false;
  }

  isSelectionVisited(item: any, branchId: number, categoryId: number): boolean {
    if (!item.visits || item.visits.length === 0) return false;

    // Para custom hopping, verificar si existe una visita con branchId Y categoryId
    return item.visits.some((visit: any) =>
      visit.branchId === branchId && visit.categoryId === categoryId
    );
  }

  isProductSelected(item: any, branchId: number, categoryId: number, productId: number): boolean {
    if (!item.visits || item.visits.length === 0) return false;

    // Verificar si existe una visita con branchId, categoryId Y productId
    return item.visits.some((visit: any) =>
      visit.branchId === branchId &&
      visit.categoryId === categoryId &&
      visit.productId === productId
    );
  }

  toggleSchedule(branchId: number): void {
    this.expandedScheduleBranchId = this.expandedScheduleBranchId === branchId ? null : branchId;
  }

  branchHasSchedules(branch: any): boolean {
    return branch && branch.schedules && branch.schedules.length > 0;
  }

  eventHasAnySchedules(eventBranches: any[]): boolean {
    if (!eventBranches || eventBranches.length === 0) return false;
    return eventBranches.some(eb => this.branchHasSchedules(eb.branch));
  }

  branchesHaveAnySchedules(branches: any[]): boolean {
    if (!branches || branches.length === 0) return false;
    return branches.some(b => this.branchHasSchedules(b));
  }

}
